export default __webpack_public_path__ + "static/media/settings.8a29fa93.svg";